import { 年金被保険者区分 } from "./types";

export function calculate月間年金保険料(
  年齢: number,
  区分: 年金被保険者区分,
  標準報酬月額: number,     // 会社員用
  厚生年金本人負担率: number, // 例: 0.0915 (18.3%の半分)
  国民年金月額: number        // 例: 16980 (令和6年度の定額)
): number {

  // 1. 厚生年金（会社員＝第2号）は70歳で強制終了
  if (区分 === '会社員' && 年齢 >= 70) return 0;

  // 2. 国民年金（第1号・第3号）は60歳で終了
  if (区分 !== '会社員' && 年齢 >= 60) return 0;

  // 3. 20歳未満は原則無料（※ただし会社員は年齢不問で引かれる！）
  if (区分 !== '会社員' && 年齢 < 20) return 0;

  // --- ここから下は「払うべき年齢の人」の計算 ---
  switch (区分) {
    case '会社員':
      // 第2号被保険者（標準報酬月額 × 9.15%、切り捨て）
      return Math.floor(標準報酬月額 * 厚生年金本人負担率);

    case '配偶者被扶養者':
      // 第3号被保険者（専業主婦・夫などは無料！）
      return 0;

    case '自営業者':
      // 第1号被保険者（フリーランスや20歳以上の学生は毎月「定額」！）
      return 国民年金月額; 
  }
}